import React from 'react';
import { AxiosResponse } from 'axios';

import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { UploadLoading } from '../../../shared/components/UploadLoading';
import { NewsSpreadsheetUploadInput } from './NewsSpreadsheetUploadInput';
import { NewsSpreadsheetUploadResult } from './NewsSpreadsheetUploadResult';
import { newsSpreadsheetUploadResultInitial, NewsSpreadsheetUploadResultModel } from '../../../Models/NewsSpreadsheetUploadResultModel';
import { NewsSpreadsheetUploadModel } from '../../../Models/NewsSpreadsheetUploadModel';
import SpreadsheetService from '../../../Services/SpreadsheetService';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { AuthContext } from '../../Authentication/AuthContext';
import { HomeContext } from '../../Home/HomeContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { ErrorHelper } from '../../../shared/ErrorHelper';

export function NewsSpreadsheetUpload() {

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);

    const [status, setStatus] = React.useState(StatusUpload.INPUT);
    const [file, setFile] = React.useState<File | null>(null);
    const [resultUpload, setResultUpload] = React.useState<NewsSpreadsheetUploadResultModel>(newsSpreadsheetUploadResultInitial);

    async function callUpload(data: NewsSpreadsheetUploadModel, file: File) {
        setFile(file);

        const formData = new FormData();
        formData.append('documentData', JSON.stringify(data));
        formData.append('file', file);

        setStatus(StatusUpload.LOADING);

        SpreadsheetService
            .postSpreadsheetFile(authContext.login.user.id, formData)
            .then((res: AxiosResponse) => {
                setResultUpload({ ...res.data.object, status: StatusResult.SUCCESS });
                setStatus(StatusUpload.FINISH);
            }).catch((error) => {
                if (!error.data || error.data.status == 500) {
                    setResultUpload({ ...newsSpreadsheetUploadResultInitial, message: error.toString(), title: 'Exibir detalhes do problema', property: 'Repository', status: StatusResult.ERROR });
                    setStatus(StatusUpload.FINISH);
                } else {
                    const errorResponse: IErrorResponse = ErrorHelper(error);
                    setResultUpload({ ...newsSpreadsheetUploadResultInitial, message: errorResponse.message, title: 'Exibir detalhes do problema', property: error.data.errors[0].property, status: StatusResult.ERROR });
                    setStatus(StatusUpload.FINISH);
                }
            });
    }

    const handleStartClassification = () => {
        homeContext.setSpreadsheetId(resultUpload.id);
        homeContext.setPageLocation(PageLocation.CLASSIFICATION);
    };

    return (
        <div >
            {status === StatusUpload.INPUT && (
                <NewsSpreadsheetUploadInput changeUpload={(data: NewsSpreadsheetUploadModel, file: File) => callUpload(data, file)} />)}
            {status === StatusUpload.LOADING && (
                <UploadLoading nameFile={file?.name ?? ''} />)}
            {status === StatusUpload.FINISH && (
                <NewsSpreadsheetUploadResult
                    nameFile={file?.name ?? ''}
                    result={resultUpload}
                    onClickHistory={() => homeContext.setPageLocation(PageLocation.HISTORY)}
                    onClickStartClassification={handleStartClassification}
                    onClickNewUpload={() => { setStatus(StatusUpload.INPUT); }} />)}
        </div>
    );
}